import styled from 'styled-components';

export const SortingText = styled.div`
    height: 100%;
    white-space: pre-wrap;
    word-wrap: break-word;
    padding-right: ${props => (props.isDisabled ? 0 : '13px')};
`;
